import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdmin, ADMIN_REDIRECT_PATH } from '../utils/rbac';

const AdminRoute: React.FC = () => {
  const { user, loading } = useAuth();
  
  // Loading state
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // Check if user is admin
  if (!isAdmin(user)) return <Navigate to={ADMIN_REDIRECT_PATH} replace />;
  
  return <Outlet />;
};

export default AdminRoute;
